import React, { useEffect, useContext, useState, useCallback } from "react";
import instance from "../../services/api";
import Spinner from "../spinner";
import { Snackbar } from "@material-ui/core";
import { Context } from "../../store/Context";

/**
 * UniversalLoader is a component that shows a loading spinner while making API requests using Axios.
 */
const UniversalLoader = () => {
  const [state, dispatch] = useContext(Context)

  const [snackbar, setSnackbar] = useState({
      isActive: false,
      message: "",
  });

  const handleSnackClose = () => {
      setSnackbar({
        isActive: false,
        message: "",
      });
  };

  const handleNoInternetSnackbar = () => {
    setSnackbar({
      isActive: true,
      message:
        "Oops! It seems there's a problem with the network. Please check your connection.",
    });
  };

  const handleServerIssueSnackbar = () => {
    setSnackbar({
      isActive: true,
      message:
        "There's a server issue. Please try again later.",
    });
  };

  // Creating a function to handle interceptor logic
  const interceptorsHandler = useCallback(() => {
    const requestInterceptor = instance.interceptors.request.use(config => {
      if (config?.withUniversalLoader) {
        dispatch({ type: "SHOW_UNIVERSAL_LOADER" });
      }
      return config;
    },
    (error) => {
      if(!error?.data && !error?.headers){
        handleNoInternetSnackbar()
      }
    }
    );

    const responseInterceptor = instance.interceptors.response.use(
      response => {
        if(response?.config?.withUniversalLoader){
          dispatch({ type: "HIDE_UNIVERSAL_LOADER" });
        }
        return response;
      },
      error => {
        if (error?.config?.withUniversalLoader) {
          dispatch({ type: "HIDE_UNIVERSAL_LOADER" });
        }
        if (!error?.data && !error?.headers) {
          handleNoInternetSnackbar();
        } else if (error?.status >= 500) {
          handleServerIssueSnackbar();
        }
        throw error;
      }
    );

    // Returning a cleanup function to eject the interceptors when unmounted
    return () => {
      instance.interceptors.request.eject(requestInterceptor);
      instance.interceptors.response.eject(responseInterceptor);
    };
  }, [dispatch])

  // Adding an effect that runs the interceptor logic
  useEffect(() => {
    const ejectInterceptors = interceptorsHandler();
    return () => {
      // Cleaning up the interceptors when the component unmounts
      ejectInterceptors();
    };
  }, [interceptorsHandler]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar.isActive}
        onClose={handleSnackClose}
        message={snackbar.message}
        autoHideDuration={2000}
      />
      {state?.showUniversalLoader && <Spinner />}
    </>
  );
};

export default UniversalLoader;
